import getShorterText from "Common/componentUtils/getShorterText";
import { themeVariables } from "Components/theme";
import filter from "lodash/filter";
import includes from "lodash/includes";
import map from "lodash/map";
import Feature from "ol/Feature";
import { Point } from "ol/geom";
import React, { memo, useCallback, useEffect, useRef } from "react";
import { RLayerCluster, RStyle } from "rlayers";
import { RBackground, RFill, RText } from "rlayers/style";
import { MAX_RESOLUTION_SHOW_NAMES } from "../constants";
import getFeaturePointNameData from "../utils/getFeaturePointNameData";
import getIsInTimelineInterval from "../utils/getIsInTimelineInterval";
import { clusterDistance, rFontSmall } from "../utils/map.utils";
function NamesCluster(props) {
    const rLayerClusterRef = useRef(null);
    const firstTimeRendered = useRef(false);
    const timelineIntervalRef = useRef(props.timelineInterval);
    useEffect(() => {
        var _a;
        timelineIntervalRef.current = props.timelineInterval;
        firstTimeRendered.current && ((_a = rLayerClusterRef.current) === null || _a === void 0 ? void 0 : _a.cluster.changed());
    }, [props.timelineInterval]);
    const cacheId = useCallback((feature) => {
        var _a;
        const data = getFeaturePointNameData([feature]);
        const isInTimelineInterval = getIsInTimelineInterval(data, timelineIntervalRef.current);
        return `${data.length === 1 ? `single_${((_a = data[0]) === null || _a === void 0 ? void 0 : _a.name) || ""}` : "multi"}_${isInTimelineInterval}`;
    }, []);
    const clusterRender = useCallback((feature) => {
        var _a;
        const data = getFeaturePointNameData([feature]);
        const isInTimelineInterval = getIsInTimelineInterval(data, timelineIntervalRef.current);
        if (data.length !== 1 || !((_a = data[0]) === null || _a === void 0 ? void 0 : _a.name) || !isInTimelineInterval)
            return React.createElement(React.Fragment, null);
        return (React.createElement(RText, { text: getShorterText(data[0].name, 40) || "", font: rFontSmall, padding: [3, 5, 3, 10], textAlign: "left", offsetX: 15, offsetY: -15 },
            React.createElement(RBackground, null,
                React.createElement(RFill, { color: "rgba(255, 255, 255, 0.8)" })),
            React.createElement(RFill, { color: themeVariables["text-color"] })));
    }, []);
    useEffect(() => {
        if (rLayerClusterRef.current) {
            const features = map(filter(props.data, e => !includes(props.deleted, e.id)), d => new Feature({
                geometry: new Point(d.coordinates[0]),
                data: d
            }));
            rLayerClusterRef.current.cluster.clear();
            features.length && rLayerClusterRef.current.cluster.addFeatures(features);
            firstTimeRendered.current = true;
        }
    }, [props.data, props.deleted]);
    return (React.createElement(RLayerCluster, { maxResolution: MAX_RESOLUTION_SHOW_NAMES, ref: rLayerClusterRef, distance: clusterDistance },
        React.createElement(RStyle.RStyle, { cacheSize: 1024, cacheId: cacheId, render: clusterRender })));
}
export default memo(NamesCluster);
